/**
 * Socket IO events for individually opened event (in dialog)
 */
export default {
  data () {
    return {
      connectedToEcho: false
    }
  },
  methods: {
    ioListen () {
      if (this.connectedToEcho || !this.id) {
        return
      }

      /**
       * Listen for events emit by other staff for this appointment
       */

      this.$echo
        .private('Company.Appointment.' + this.id)
        // Trigger when another staff member has updated this event status
        .listenForWhisper('statusUpdate', ({ id, status }) => {
          if (this.eventObject && this.eventObject.id === id) {
            this.eventObject.status = status
            this.$q.notify({
              color: 'orange',
              textColor: 'black',
              message: 'Another staff member has updated this appointment status'
            })
          }
        })
        // Trigger when another staff member has updated this event status
        .listenForWhisper('updateLock', ({ id, state }) => {
          if (this.eventObject && this.eventObject.id === id) {
            this.eventObject.is_locked = state
            this.$q.notify({
              color: 'orange',
              textColor: 'black',
              message: 'Another staff member has updated this appointment lock state'
            })
          }
        })
        // Trigger when another staff member has updated this event
        .listenForWhisper('update', id => {
          if (this.eventObject && this.eventObject.id === id) {
            this.getAppointment()
            this.$q.notify({
              color: 'orange',
              textColor: 'black',
              message: 'Another staff member has updated the details for this appointment'
            })
          }
        })
        // Trigger when another staff member has removed this event
        .listenForWhisper('remove', id => {
          if (this.eventObject && this.eventObject.id === id) {
            this.close()
            this.$q.dialog({
              title: 'Archived',
              message: 'Another staff member has archived this appointment'
            })
          }
        })

      this.connectedToEcho = true
    },
    ioDisconnect () {
      this.$echo.leave('Company.Appointment.' + this.id)
      this.connectedToEcho = false
    }
  },
  beforeUnmount () {
    this.ioDisconnect()
  }
}
